import { useState } from "react";
import {
  Box,
  Flex,
  Button,
  Spacer,
  Image,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  VStack,
  Link as ChakraLink,
  Divider,
} from "@chakra-ui/react";
import { HamburgerIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Link, useLocation } from "react-router-dom";
import chrome from "../../assets/home/Chrome.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: "HOME", path: "/" },
    { label: "PORTFOLIO", path: "/portfolio" },
    { label: "ABOUT US", path: "/about-us" },
    { label: "CAREER", path: "/carrer" },
    { label: "BLOG", path: "/blog" },
    { label: "OUR SERVICES", path: "/our-service" },
    { label: "OUR TEAM", path: "/our-team" },
  ];

  const isActive = (path) => location.pathname === path;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      bg="rgba(215, 215, 215, 0.2)"
      m={{ base: "0", md: "12px" }}
      px={{ base: 4, md: 8 }}
      py={3}
      backdropFilter="blur(10px)"
      position="fixed"
      width={{ base: "100%", md: "calc(100% - 24px)" }}
      zIndex={999}
    >
      <Flex align="center" justify={{ base: "space-between", md: "start" }}>
        <IconButton
          display={{ base: "block", md: "none" }}
          icon={<HamburgerIcon />}
          variant="ghost"
          aria-label="Open Menu"
          color="white"
          onClick={handleToggle}
          zIndex={101}
        />

        <Box
          flex="1"
          textAlign={{ base: "center", md: "left" }}
          ml={{ base: "120px", md: "-60px" }}
        >
          <Link to="/">
            <Image src={chrome} alt="Doggle Logo" w="50px" h="auto" mx="auto" />
          </Link>
        </Box>

        <Spacer />
        <Flex
          gap={6}
          color="white"
          fontWeight="bold"
          fontSize="sm"
          display={{ base: "none", md: "flex" }}
          alignItems="center"
        >
          {navLinks.map((nav) => (
            <Link key={nav.path} to={nav.path}>
              <Box
                px={2}
                py={1}
                position="relative"
                _hover={{
                  _after: {
                    content: '""',
                    position: "absolute",
                    bottom: "0",
                    left: "2",
                    right: "2",
                    height: "1px",
                    bg: "white",
                  },
                }}
              >
                {nav.label}
                {isActive(nav.path) && (
                  <Box
                    as="span"
                    position="absolute"
                    bottom="0"
                    left="2"
                    right="2"
                    height="1px"
                    bg="white"
                  />
                )}
              </Box>
            </Link>
          ))}
        </Flex>

        <Spacer />
        <Box display={{ base: "none", md: "block" }}>
          <Link to="/contact-us">
            <Button
              borderRadius={16}
              bg="#005770"
              color="white"
              rightIcon={<ChevronRightIcon />}
              _hover={{ bg: "teal.700" }}
            >
              Contact Us
            </Button>
          </Link>
        </Box>
      </Flex>

      {/* Mobile Navigation Drawer */}
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={() => setIsOpen(false)}
        size="full"
      >
        <DrawerOverlay />
        <DrawerContent bg="#FDF7EF">
          <DrawerCloseButton
            left="10px"
            top="10px"
            color="black"
            _hover={{ bg: "rgba(0,0,0,0.1)" }}
          />

          <DrawerBody mt={12}>
            <VStack align="start" spacing={4} fontWeight="bold" w="full">
              {navLinks.map((nav) => (
                <Box key={nav.path} w="full">
                  <ChakraLink
                    as={Link}
                    to={nav.path}
                    onClick={() => setIsOpen(false)}
                    w="full"
                    px={4}
                    py={3}
                    borderRadius={4}
                    bg={
                      isActive(nav.path)
                        ? "rgba(0, 87, 112, 0.5)"
                        : "transparent"
                    }
                    _hover={{ bg: "rgba(0, 87, 112, 0.3)" }}
                    color="black"
                    display="block"
                  >
                    {nav.label}
                  </ChakraLink>
                  <Divider />
                </Box>
              ))}
              <Box w="full">
                <ChakraLink
                  as={Link}
                  to="/contact-us"
                  onClick={() => setIsOpen(false)}
                  w="full"
                  px={4}
                  py={3}
                  borderRadius={4}
                  bg={
                    isActive("/contact-us")
                      ? "rgba(0, 87, 112, 0.5)"
                      : "transparent"
                  }
                  _hover={{ bg: "rgba(0, 87, 112, 0.3)" }}
                  color="black"
                  display="block"
                >
                  Contact Us
                </ChakraLink>
                <Divider />
              </Box>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default Navbar;
